import React, { useState } from "react";
import axios from "axios";
import { useAuth } from "./AuthContext";

const RegisterPage = ({ onRegisterSuccess, onSwitchToLogin }) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [errore, setErrore] = useState("");
  const { login } = useAuth(); // ⬅️ importa login

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrore("");

    try {
      // ✅ 1. Registrazione
      await axios.post("http://localhost:8000/auth/register", {
        email,
        password,
      });

      // ✅ 2. Login automatico dopo registrazione
      await login(email, password);

      // ✅ 3. Entra nell’app
      onRegisterSuccess();
    } catch (err) {
      console.error("Errore registrazione:", err);
      setErrore("❌ Registrazione fallita. Email già usata?");
    }
  };

  return (
    <div className="min-h-screen flex justify-center items-center">
      <form onSubmit={handleSubmit} className="bg-white p-6 rounded shadow w-80">
        <h2 className="text-xl font-bold mb-4">Registrati</h2>
        {errore && <p className="text-red-600">{errore}</p>}
        <input
          className="w-full p-2 border mb-2 rounded"
          type="email"
          placeholder="Email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
        />
        <input
          className="w-full p-2 border mb-4 rounded"
          type="password"
          placeholder="Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
        />
        <button className="w-full bg-green-500 text-white py-2 rounded hover:bg-green-600">
          Registrati
        </button>
        <p className="text-sm mt-2 text-center">
          Hai già un account?{" "}
          <span onClick={onSwitchToLogin} className="text-blue-500 cursor-pointer underline">
            Accedi
          </span>
        </p>
      </form>
    </div>
  );
};

export default RegisterPage;
